export const serviceDetailActions = {
  OPEN_SERVICE_DETAIL: "OPEN_SERVICE_DETAIL",
  CLOSE_SERVICE_DETAIL: "CLOSE_SERVICE_DETAIL",
  SET_SERVICE_DATA: "SET_SERVICE_DATA",
  REMOVE_SERVICE:"REMOVE_SERVICE"
};
